import { Checkbox, Col, Input, Row, Select } from 'antd';
import React from 'react';
import strings from '../../eyeguide-localization/reports/string.filter';
import Constants from '../common/constants';

const genderOptions = [{label: 'Female', value: '0'}, {label: 'Male', value: '1'}, 
                       {label: 'Other', value: '2'}, {label: 'Unspecified', value: '3'}];

interface ICustomFilter {
    firstname: string | null;
    lastname: string | null;
    middlename: string | null;
    profileID: string | null;
    score: Array<any> | null;
    sport: string | undefined;
    level: string | undefined;
    gender: Array<any> | undefined;
    range: string | undefined;
}

interface IfilterState {

}

interface IfilterProps {
    setCustom: Function;
    custom: ICustomFilter;
    isPrivacyEnabled: boolean;
}

class CustomFilter extends React.Component<IfilterProps, IfilterState> {

    constructor(props: IfilterProps) {
        super(props);
    }

    render() {
        var { custom, setCustom, isPrivacyEnabled } = this.props;
        return (
            <Col style={{width: '100%'}}>
                <Row>&nbsp;</Row>
                <Row type="flex">
                    <Col className="filterCard-2-Row">
                        <Row className="filterHeader allCheckRow">{strings.isCustomTxt}</Row>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row hidden={isPrivacyEnabled} className="filterSubRows">
                    <Col xs={8} sm={8} md={5} lg={4} xl={4}>
                        <Row >{strings.isFirstnameTxt}:</Row>
                    </Col>
                    <Col  xs={14} sm={14} md={16} lg={10} xl={11}>
                        <Row>
                            <Input 
                                value={custom.firstname} 
                                placeholder={'e.g. Johnny'} 
                                onChange={(e: any) => setCustom({firstname: e.target.value})}
                            />
                        </Row>
                    </Col>
                </Row>
                <Row hidden={isPrivacyEnabled} className="filterSubRows">
                    <Col xs={8} sm={8} md={5} lg={4} xl={4}>
                        <Row >{strings.isMiddlenameTxt}:</Row>
                    </Col>
                    <Col  xs={14} sm={14} md={16} lg={10} xl={11}>
                        <Row>
                            <Input 
                                placeholder={'e.g. Mark'} 
                                value={custom.middlename}
                                onChange={(e: any) => setCustom({middlename: e.target.value})}
                            />
                        </Row>
                    </Col>
                </Row>
                <Row hidden={isPrivacyEnabled} className="filterSubRows">
                    <Col xs={8} sm={8} md={5} lg={4} xl={4}>
                        <Row >{strings.isLastnameTxt}:</Row>
                    </Col>
                    <Col  xs={14} sm={14} md={16} lg={10} xl={11}>
                        <Row>
                            <Input 
                                placeholder={'e.g. Riggs'} 
                                value={custom.lastname}
                                onChange={(e: any) => setCustom({lastname: e.target.value})}
                            />
                        </Row>
                    </Col>
                </Row>
                <Row className="filterSubRows">
                    <Col xs={8} sm={8} md={5} lg={4} xl={4}>
                        <Row >{strings.isIdTxt}:</Row>
                    </Col>
                    <Col  xs={14} sm={14} md={16} lg={10} xl={11}>
                        <Row>
                            <Input 
                                placeholder={'e.g. 12345'}
                                value={custom.profileID}
                                onChange={(e: any) => setCustom({profileID: e.target.value})}
                            />
                        </Row>
                    </Col>
                </Row>
                <Row className="filterSubRows">
                    <Col xs={8} sm={8} md={5} lg={4} xl={4}>
                        <Row >{strings.isTestScore}:</Row>
                    </Col>
                    <Col  xs={14} sm={14} md={16} lg={10} xl={11}>
                        <Row>
                            {/* <Input 
                                placeholder={'e.g. 12345'} 
                                value={custom.score}
                                onChange={(e: any) => setCustom({score: e.target.value})}
                            /> */}
                            <Input.Group  >
                                <Input 
                                    style={{ width: 'calc( 50% - 17px)', textAlign: 'center' }} 
                                    placeholder="Minimum" 
                                    value={custom.score ? custom.score[0] : ''}
                                    onChange={
                                        (e) => setCustom({
                                            score: [ e.target.value, custom.score ? custom.score[1] : '' ]
                                        })
                                    }
                                />
                                <Input 
                                    style={{ 
                                        width: 34, 
                                        borderLeft: 0, 
                                        pointerEvents: 'none', 
                                        backgroundColor: '#fff' 
                                    }} 
                                    placeholder="~" 
                                    disabled={true}
                                />
                                <Input 
                                    style={{ width: 'calc( 50% - 17px)', textAlign: 'center', borderLeft: 0 }} 
                                    placeholder="Maximum"
                                    value={custom.score ? custom.score[1] : ''}
                                    onChange={
                                        (e) => setCustom({
                                            score: [ custom.score ? custom.score[0] : '', e.target.value ]
                                        })
                                    }
                                />
                            </Input.Group>
                        </Row>
                    </Col>
                </Row>
                <Row className="filterSubRows">
                    <Col xs={8} sm={8} md={5} lg={4} xl={4}>
                        <Row >{strings.isSportTxt}:</Row>
                    </Col>
                    <Col  xs={14} sm={14} md={16} lg={10} xl={11}>
                        <Row>
                            <Select 
                                getPopupContainer={this.getContainer} 
                                showSearch={true} 
                                placeholder="Select a sport." 
                                style={{ width: '100%' }}
                                value={custom.sport}
                                onChange={(e: any) => setCustom({sport: e})}
                                allowClear={true}
                            >
                                {this.renderOptions(Constants.getSports())}
                            </Select>
                        </Row>
                    </Col>
                </Row>
                <Row className="filterSubRows">
                    <Col xs={8} sm={8} md={5} lg={4} xl={4}>
                        <Row >{strings.isLevelTxt}:</Row>
                    </Col>
                    <Col  xs={14} sm={14} md={16} lg={10} xl={11}>
                        <Row>
                            <Select 
                                getPopupContainer={this.getContainer} 
                                showSearch={true} 
                                placeholder="Select a level." 
                                style={{ width: '100%' }} 
                                value={custom.level}
                                onChange={(e: any) => setCustom({level: e})}
                                allowClear={true}
                            >
                                {this.renderOptions(Constants.getLevels())}
                            </Select>
                        </Row>
                    </Col>
                </Row>
                <Row className="filterSubRows">
                    <Col xs={8} sm={8} md={5} lg={4} xl={4}>
                        <Row >{strings.isTestThreshold}:</Row>
                    </Col>
                    <Col  xs={14} sm={14} md={16} lg={10} xl={11}>
                        <Row className="checkRowBox_1">
                            <Select 
                                getPopupContainer={this.getContainer} 
                                showSearch={true} 
                                placeholder="Select a range." 
                                style={{ width: '100%' }} 
                                value={custom.range}
                                onChange={(e: any) => setCustom({range: e})}
                                allowClear={true}
                            >
                                {this.renderOptions(Constants.getTestTypes())}
                            </Select>
                        </Row>
                    </Col>
                </Row>
                <Row className="filterSubRows">
                    <Col xs={8} sm={8} md={5} lg={4} xl={4}>
                        <Row >{strings.isGenderTxt}:</Row>
                    </Col>
                    <Col  xs={14} sm={14} md={16} lg={10} xl={11}>
                        <Row className="checkRowBox_1">
                            <Checkbox.Group 
                                options={genderOptions} 
                                value={custom.gender}
                                onChange={(e: any) => setCustom({gender: e})}
                            />
                        </Row>
                    </Col>
                </Row>
            </Col>
        );
    }

    /**
     * Attatches dropdown lists to parent containers to avoid displacement during scroll
     */
    private getContainer = (triggernode: any) => {
        // debugger;
        return triggernode.parentNode;
    }

    private renderOptions = (options: Array<any>) => {
        return options.map(sport => {
            return (
                <Select.Option key={sport} value={sport}>
                    {sport}
                </Select.Option>
            );
        });
    }
}

export default CustomFilter;


// WEBPACK FOOTER //
// ./src/components/reports/reports.customfilter.tsx